var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"change":_vm.handleColorChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }